module.exports = __webpack_public_path__ + "static/media/Pen-Blue.9d1ca57b.svg";